import styled from 'styled-components'
import { Breadcrumbs as DdsBreadcrumbs } from '@diversioteam/diversio-ds'

import { media } from 'styles/theme/mediaQueries'

export const Container = styled.div`
    display: flex;
    align-items: center;
`

export const Links = styled.div`
    box-sizing: border-box;
    display: flex;
    position: relative;
    align-items: center;

    ${media.lg} {
        width: 231px;

        &:after {
            content: '';
            width: 1px;
            height: 38px;
            background-color: ${({ theme }) => theme.colors.primaryGray2};
            position: absolute;
            right: 0;
        }
    }

    > a {
        &:not(:last-child) {
            margin-right: 20px;
        }
    }
`

export const Breadcrumbs = styled(DdsBreadcrumbs)`
    &.dds-breadcrumbs {
        margin-left: auto;
        margin-right: auto;

        ${media.lg} {
            margin-left: 40px;
            margin-right: none;
        }
    }

    .MuiBreadcrumbs-li a {
        color: ${({ theme }) => theme.colors.secondary500};
        font-size: 12px;
        text-transform: capitalize;
    }
`
